import type { IndexDef, ObjectiveEvent } from '@/api/types/readiness'
import { levelNum } from '@/api/types/readiness'
import { stateAt, scoresOf } from '@/lib/readiness/series'

// ── Progress figures (Iteration 3 §3, §4) ───────────────────────────────────

const DAY = 86_400_000

const isLevelEvent = (e: ObjectiveEvent) => (e.event_type === 'confirmed' || e.event_type === 'declared' || e.event_type === 'overridden') && e.to_level != null && e.from_level != null && e.from_level !== e.to_level

// Level moves in a window, with coverage-driven drops counted apart (§4.1).
export function movesSince(events: ObjectiveEvent[], sinceIso: string) {
  const xs = events.filter((e) => e.occurred_at >= sinceIso && isLevelEvent(e))
  const up = xs.filter((e) => levelNum(e.to_level!) > levelNum(e.from_level!))
  const down = xs.filter((e) => levelNum(e.to_level!) < levelNum(e.from_level!))
  return { up, down: down.filter((e) => e.cause !== 'coverage'), coverage: down.filter((e) => e.cause === 'coverage') }
}

// The scope_expanded event that preceded a coverage-driven drop (for "+312 assets").
export function scopeGrowthFor(events: ObjectiveEvent[], drop: ObjectiveEvent): number | null {
  const se = [...events].filter((e) => e.event_type === 'scope_expanded' && e.objective_code === drop.objective_code && e.occurred_at <= drop.occurred_at).pop()
  return se && se.assets_known_to != null && se.assets_known_from != null ? se.assets_known_to - se.assets_known_from : null
}

// Pace (§3.2): score change per month over the last two quarters; coverage-driven
// drops (and the recovery that undoes them) never lower it. Display only.
export function paceOf(index: IndexDef, events: ObjectiveEvent[], now = new Date()): number {
  const drops = new Set(events.filter((e) => e.cause === 'coverage').map((e) => e.id))
  const filtered = events.filter((e) => !drops.has(e.id))
  const then = new Date(now.getTime() - 182 * DAY).toISOString()
  const a = scoresOf(index, stateAt(index, filtered, then)).score_confirmed_only
  const b = scoresOf(index, stateAt(index, filtered, now.toISOString())).score_confirmed_only
  return Math.round(((b - a) / 6) * 10) / 10
}
